import React from "react";
import { useLang } from "../i18n/LanguageContext";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../components/ui/accordion";
import { Link } from "react-router-dom";
import { MessageCircle, ArrowRight } from "lucide-react";
import { whatsappUrl } from "../lib/office";

export default function FAQ() {
  const { t } = useLang();
  const items = t("faq.items") || [];

  return (
    <div>
      <section className="border-b border-border-light">
        <div className="container-notary py-20 md:py-24">
          <div className="overline mb-4">{t("faq.eyebrow")}</div>
          <h1 className="text-4xl md:text-5xl font-serif text-charcoal max-w-3xl">{t("faq.title")}</h1>
          <span className="divider-gold my-6 block" />
          <p className="text-lg text-charcoal-muted max-w-2xl">{t("faq.subtitle")}</p>
        </div>
      </section>

      <section className="container-notary py-16 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="border border-border-light" data-testid="faq-accordion">
            {items.map((it, i) => (
              <AccordionItem key={it.q} value={`q-${i}`} className="border-b border-border-light last:border-b-0">
                <AccordionTrigger
                  className="px-6 py-5 hover:no-underline hover:bg-base text-start font-serif text-lg"
                  data-testid={`faq-q-${i}`}
                >
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 text-charcoal-muted leading-relaxed">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <aside className="lg:col-span-4">
          <div className="border border-border-light p-8 bg-surface-muted">
            <div className="overline mb-3">{t("common.bookAppointment")}</div>
            <h3 className="font-serif text-2xl text-charcoal">{t("home.ctaTitle")}</h3>
            <span className="divider-gold my-4 block" />
            <p className="text-sm text-charcoal-muted">{t("home.ctaDesc")}</p>
            <div className="mt-6 flex flex-col gap-3">
              <Link to="/rendez-vous" className="btn-gold" data-testid="faq-cta-appointment">
                {t("common.bookAppointment")}
                <ArrowRight className="w-4 h-4 rtl-flip" />
              </Link>
              <a
                href={whatsappUrl(t("whatsappMessages.general"))}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-outline-dark"
                data-testid="faq-cta-whatsapp"
              >
                <MessageCircle className="w-4 h-4" />
                {t("common.whatsapp")}
              </a>
            </div>
          </div>
        </aside>
      </section>
    </div>
  );
}
